<template>
  <div
    class="modal fade"
    id="hospital-acc-modal"
    tabindex="-1"
    aria-labelledby="hospital-acc-modal-label"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="max-width: 600px !important;">
      <div class="modal-content certi-modal-border-radius" style="text-align: center;">
        <div 
          class="modal-header text-center" 
          style="justify-content: center;"
          
        >
          <div class="modal-header-flex">
            <h1 class="modal-title" id="staticBackdropLabel">
              {{ $t('hospital_modal_title') }}
            </h1>
            <div class="btn-close-wrap">
              <button
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i class="fa-regular fa-xmark" />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-body text-center">
          <div class="modal-div-wrap">
            <div class="modal-input-div">
              <div class="label-wrap">
                <label >IP</label>
              </div>
              <input 
              type="text"
              disabled
              :value="selectedAccountInfo.ip || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label >{{ $t('hospital_modal_device') }}</label>
              </div>
              <input 
              type="text"
              disabled
              :value="selectedAccountInfo.agent || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label >{{ $t('hospital_modal_recent_login') }}</label>
              </div>
              <input 
              type="text"
              disabled
              :value="convertDateTime(selectedAccountInfo.lastLoginAt) || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label >{{ $t('hospital_modal_first_login') }}</label>
              </div>
              <input 
              type="text"
              disabled
              :value="convertDateTime(selectedAccountInfo.firstLoginAt) || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label >{{ $t('hospital_modal_status') }}</label>
              </div>
              <input 
                type="text"
                disabled
                :value="computedIsLoggedIn"
              />
              <button 
                class="logout-btn btn-hover" :class="selectedAccountInfo.isLoggedIn ? '' : 'disabled'"
                @click="logoutUser"  
              >
                {{ $t('hospital_modal_logout_btn') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertDateTime } from '@/utils/utils';
export default {
  data() {
    return {
      convertDateTime,
      ip: '',
      agent: '',
      lastLoginAt: '',
      firstLoginAt: '',
      refreshToken: '',
      isLoggedIn: false,
    };
  },
  computed: {
    computedIsLoggedIn() {
      if(!this.selectedAccountInfo.isLoggedIn) return this.$i18n.t('hospital_modal_logout_status_true');
      return this.$i18n.t('hospital_modal_logout_status_false');
    },
  },
  props: {
    selectedAccountInfo: {
      ip: {
        type: String,
        required: false,
      },
      agent: {
        type: String,
        required: false,
      },
      lastLoginAt: {
        type: String,
        required: false,
      },
      firstLoginAt: {
        type: String,
        required: false,
      },
      refreshToken: {
        type: String,
        required: false,
      },
      username: {
        type: String,
        required: false,
      },
      companyId: {
        type: String,
        required: false,
      },
      isLoggedIn: {
        type: Boolean,
        required: false,
      }
    },
  },
  watch : {
    selectedAccountInfo: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
      },
    },
  },
  mounted() {
  },

  methods: {
    async logoutUser() {
      // console.log(this.selectedAccountInfo.isLoggedIn)
      if(!this.selectedAccountInfo.isLoggedIn) return;
      const obj = {};
      obj.companyId = this.selectedAccountInfo.companyId;
      obj.username = this.selectedAccountInfo.username; 
      // console.log(obj)
      this.$emit('logoutUser', obj);
    },
  },
};
</script>
<style scoped>
.modal-div-wrap .modal-input-div {
  display: flex;
  gap: 10px;
  
}

.modal-dialog .modal-content .modal-header {
  padding: 0px 14px 0px 20px !important;
  border-bottom: 1px solid rgba(0,0,0,0.1) !important;
  height: 52px !important;
  display: flex;
  align-items: center;
}
.modal-div-wrap .modal-input-div label{
  width: 110px;
}

.modal-dialog .modal-content .modal-body {
  padding-bottom :20px;
}
.modal-div-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modal-input-div {
  padding: 0px !important;
}

.logout-btn {
  height: 40px;
  padding: 0 20px;
  border-radius: 8px;
  background-color: #2F3337;
  white-space: pre;
  color: white;
}

.logout-btn.disabled {
  opacity: 0.4;
}
</style>
